module.exports = __webpack_public_path__ + "static/media/officeWoman.a41f5788.png";